import { Mods, theme } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

export const Root = styled.div<StyledMods<Mods<'checked'>>>`
    transition:
        background-color ${theme.duration.fast}ms ease-in-out,
        border ${theme.duration.fast}ms ease-in-out;
    padding: 16px 12px;
    border-radius: ${theme.radius.small};
    cursor: pointer;
    position: relative;

    &:hover {
        background-color: ${theme.color.silver80};

        &&:before {
            border-bottom: none;
        }
    }

    &:not(:last-of-type)::before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        height: 1px;
        margin-left: 12px;
        margin-right: 12px;
        width: calc(100% - 12px - 12px);
        border-bottom: 1px solid ${theme.color.midnight50};
    }

    &:has(+ div:hover, + div.selected) {
        &::before {
            border-bottom: none;
        }
    }

    &.selected {
        background-color: ${theme.color.silver80};

        &&:before {
            border-bottom: none;
        }
    }
`;

export const AccountParams = styled.div`
    display: grid;
    gap: 8px;
    grid-template-columns: repeat(2, max-content);
`;
